module.exports = __webpack_public_path__ + "static/media/expried.aa0231b5.svg";